import { RiReactjsLine } from "react-icons/ri";
import { FaServer } from "react-icons/fa";

const data = [
  {
    id: 1,
    icon: <RiReactjsLine />,
    title: "Frontend Development",
    desc: "Modern UI,mobile responsiveness,accesibilty is also a great factor i consider when planning  my to build using front-end technologies i know about,as we all know people with wide range of disabilities also access the web on a daily basis when coding/building this is an important note to take into consideratoin",
  },
  {
    id: 2,
    icon: <FaServer />,
    title: "Backend Development",
    desc: "Authentication,Authorisation should be seemless when users try access your site,but mostly importantly their security should be top-secured and it gives a sense of confidence knowing that is handled effectively behind the scences.Not my strongest suite but I am currently learning how to build APIS with NodeJs and Express",
  },
];

export default data;
